import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ConsultarTransacaoCreditoService {

  private parametrosPesquisa: any;
  private formPesquisa: FormGroup;
  private realizaPesquisa: boolean;

  constructor() { }

  public getParametrosPesquisa() {
    return this.parametrosPesquisa;
  }

  public getFormPesquisa() {
    return this.formPesquisa;
  }

  public addDadosPesquisa(parametrosPesquisa: any, formPesquisa: FormGroup) {
    this.parametrosPesquisa = parametrosPesquisa;
    this.formPesquisa = formPesquisa;
  }

  public isRealizaPesquisa() {
    return this.realizaPesquisa;
  }

  public setRealizaPesquisa(realizaPesquisa: boolean) {
    this.realizaPesquisa = realizaPesquisa;
  }

  public limparDadosPesquisa() {
    this.parametrosPesquisa = null;
    this.realizaPesquisa = false;
  }

}
